"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var PaperContext = /*#__PURE__*/_react["default"].createContext({
  variant: 'paper'
});
var _default = exports["default"] = PaperContext;